export class TodayScheduleModel {
    public date : Date;
    constructor(date:Date) {
        this.date = date;
    }
}